export enum VARIANT{
    SUCCESS='success' ,
    WARNING= 'warning',
    ERROR= 'error',
    INFO= 'info' ,
    LOGIN_SUCCESS= 'loginSuccess' ,
    LOGIN_ERROR= 'loginError'
  }

export type ServerAlertDataV2 = {
    message: string,
    variant: VARIANT,
    openSnackbarV2: boolean,
    id?: string;
    title?: string;
}